@if (controlState$ | async; as controlState) {
  @if (controlState.showError && (controlState.errorMessage || customErrorMessage)) {
    <small class="p-error" [class.italic]="italic">
      {{ customErrorMessage ?? controlState.errorMessage }}
    </small>
  }
}
